import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/522'

const PurchasesAtSelectLocationsTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="capture_rate.tabs.purchases_at_select_locations"
  />
)

export default PurchasesAtSelectLocationsTab
